export default "__VITE_ASSET__BYJEyI6M__"